import { Pipe, PipeTransform } from '@angular/core';
import {
  IPersonEvaluationQuestionResponse,
  PersonEvaluationResponsesDetail
} from 'src/app/shared/models/evaluation/personEvaluationResponsesDetail';
import { AttributeUiType } from 'src/app/shared/models/attributes/attributeUiType';

@Pipe({
  name: 'evaluationAggregate',
  standalone: false
})
export class EvaluationAggregatePipe implements PipeTransform {
  constructor() {}
  transform(
    aggregate: PersonEvaluationResponsesDetail,
    type: string
  ): IPersonEvaluationQuestionResponse[] {
    if (type == 'starRatingItems') {
      return aggregate.responses.filter((x) => x.questionType == AttributeUiType.StarRating);
    }
    if (type == 'enumeratedItems') {
      return aggregate.responses.filter((x) => x.isEnumeratedType);
    }
    if (type == 'otherItems') {
      return aggregate.responses.filter(
        (x) => !x.isEnumeratedType && x.questionType != AttributeUiType.StarRating
      );
    }
  }
}
